(function() { window.GUID_89e67426_0af4_45ad_9465_58a235d776d9 = { getGuid: function() { return "89e67426-0af4-45ad-9465-58a235d776d9"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RRB extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $("#" + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off("click." + this.UniqueNamespace, ".encounter-sub-cell");
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                CS.Controls.DragZoom.BaseEvents.ControlBaseLoaded(CS.Controls.DragZoom, {
                    selector: "#dragzoom-" + me.ControlId,
                    callback: (control, e) => {
                        if (e.data instanceof CS.Controls.DragZoom) {
                            me.DragZoom = control;
                            me.discoverUI();
                            me.bindEvents();
                            me.DragZoom.RemoveContentTransparency();
                            let alreadyScrolled = Controls.DragZoom.ApplyLastScrollAndZoomState();
                            if (!alreadyScrolled) {
                                me.DragZoom.ScrollToTopLeft();
                            }
                        }
                    },
                });
                CS.Controls.DragZoom.Events.AfterUpdateTransform({
                    selector: "#dragzoom-" + me.ControlId,
                    callback: (dragzoom, ev) => {
                        // Sticky headers
                        let sticky = $(".rrb-top-header.sticky");
                        let offsetY = ev.data.ScaledOffsetY;
                        let stickyPos = sticky.offset();
                        let scrollableOffset = dragzoom.$ScrollablePart.offset();
                        let stickyOffsetY = scrollableOffset.top;
                        if (stickyPos) {
                            stickyOffsetY = stickyPos.top - scrollableOffset.top;
                        }
                        if (stickyOffsetY < 0) {
                            if (!me.topSticky) {
                                me.topSticky = sticky.clone(true, true);
                                me.topSticky.addClass("new-sticky");
                                me.topSticky.removeClass("sticky");
                                me.topSticky.insertAfter(sticky);
                            }
                            me.topSticky[0].style.transform =
                                "translate3d(0px," + -offsetY + "px, 0px)";
                            me.topSticky[0].style.scrollMarginTop = -offsetY + "px"; //Hack pour HtmlToCanvas
                        }
                        else if (me.topSticky) {
                            me.topSticky.remove();
                            me.topSticky = null;
                        }
                        sticky = $(".rrb-left-header.sticky");
                        let offsetX = ev.data.ScaledOffsetX;
                        stickyPos = sticky.offset();
                        let stickyOffsetX = scrollableOffset.left;
                        if (stickyPos) {
                            stickyOffsetX = stickyPos.left - scrollableOffset.left;
                        }
                        if (stickyOffsetX < 0) {
                            if (!me.leftSticky) {
                                me.leftSticky = sticky.clone(true, true);
                                me.leftSticky.addClass("new-sticky");
                                me.leftSticky.removeClass("sticky");
                                me.leftSticky.insertAfter(sticky);
                            }
                            me.leftSticky[0].style.transform =
                                "translate3d(" + -offsetX + "px, 0px, 0px)";
                            me.leftSticky[0].style.scrollMarginLeft = -offsetX + "px"; //Hack pour HtmlToCanvas
                        }
                        else if (me.leftSticky) {
                            me.leftSticky.remove();
                            me.leftSticky = null;
                        }
                    },
                });
            }
            discoverUI() {
                let me = this;
                me.topHeader = me.$Control.find(".rrb-top-header");
                me.leftHeader = me.$Control.find(".rrb-left-header");
            }
            bindEvents() {
                let me = this;
                me.$Control.offon("click." + this.UniqueNamespace, ".encounter-sub-cell", function (e) {
                    //if (me.DragZoom.HasMoved()) {
                    //    return;
                    //}
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    let clicked = $(this);
                    me.onEncounterClicked(clicked, e);
                });
            }
            onEncounterClicked(enc, e) {
                this.onEncounterSelected(enc, e);
            }
            onEncounterSelected($encounter, e) {
                let encounterRowId = $encounter.data("ei");
                this.highlightMatch(encounterRowId, $encounter);
                let data = {
                    matchId: $encounter.data("ei"),
                    opponentId: null,
                    matchNumber: $encounter[0].id.replace("mn-", ""),
                    $selectedEncounter: $encounter,
                };
                this.Trigger(RRB.EventNames.MatchSelectionChanged, {
                    jqueryEventObject: e,
                    data: data,
                });
            }
            highlightMatch(encounterRowId, match) {
                let oppMatch = this.$Control
                    .find("[data-ei=" + encounterRowId + "]")
                    .not(match);
                if (this.SelectedEncounter != null) {
                    this.SelectedEncounter.removeClass("highlighted");
                    this.SelectedOppEncounter.removeClass("opp-highlighted");
                }
                this.SelectedEncounter = match;
                this.SelectedOppEncounter = oppMatch;
                match.addClass("highlighted");
                oppMatch.addClass("opp-highlighted");
            }
            ReplaceContent(newContent, hasChangedOnly = false) {
                let me = this;
                let $newContent = $(newContent);
                me.$control.data("specialparameters", $newContent.data("specialparameters"));
                CS.Lag("refresh-content", 600, () => {
                    // this.ClearSelectedEncounter();
                    me.$control.removeClass("opponent-highlighted");
                    me.$control.removeClass("match-highlighted");
                    me.$control[0].innerHTML = $newContent[0].innerHTML;
                });
            }
        }
        Controls.RRB = RRB;
        (function (RRB) {
            class Events {
                static MatchSelectionChanged(param) {
                    Controls.RegisterEvent(RRB, EventNames.MatchSelectionChanged, param);
                }
            }
            RRB.Events = Events;
            class EventNames {
            }
            EventNames.MatchSelectionChanged = "bracket-match-selectionchanged";
            RRB.EventNames = EventNames;
        })(RRB = Controls.RRB || (Controls.RRB = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=rrb.js.map
